String.prototype.removeDiacritics = function(this: string) {
  return this.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
